module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal voice-modal open"
  }, [_c('div', {
    staticClass: "voice-modal-content"
  }, [_c('h1', [_vm._v("Vérification des informations dictées")]), _vm._v(" "), _c('p', {
    staticClass: "voice-warning"
  }, [_vm._v("\n            L'IA peut se tromper sur les éléments dictés — vérifiez chaque information avant de valider.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "voice-transcript"
  }, [_c('strong', [_vm._v("Ce qui a été compris")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editedTranscript),
      expression: "editedTranscript"
    }],
    staticClass: "voice-transcript-input",
    attrs: {
      "rows": "3",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.editedTranscript)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editedTranscript = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "voice-reanalyze",
    class: {
      disabled: _vm.loading || !_vm.transcriptChanged
    },
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.reanalyze
    }
  }, [_c('i', {
    staticClass: "icon-search"
  }), _vm._v("\n                " + _vm._s(_vm.loading ? 'Ré-analyse en cours…' : 'Corrigé ? Ré-analyser ce texte') + "\n            ")])]), _vm._v(" "), (_vm.visibleFields.length > 0) ? _c('div', {
    staticClass: "voice-fields"
  }, _vm._l((_vm.visibleFields), function(field) {
    return _c('label', {
      key: field.key,
      staticClass: "voice-chip",
      class: {
        checked: _vm.checked[field.key]
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checked[field.key]),
        expression: "checked[field.key]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.checked[field.key]) ? _vm._i(_vm.checked[field.key], null) > -1 : (_vm.checked[field.key])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checked[field.key],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.checked, field.key, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.checked, field.key, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.checked, field.key, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "voice-chip-content"
    }, [_c('strong', [_vm._v(_vm._s(field.label))]), _vm._v(" "), _c('span', {
      staticClass: "voice-chip-values"
    }, [_c('span', {
      staticClass: "voice-current"
    }, [_vm._v(_vm._s(_vm.formatValue(field, _vm.current[field.key])))]), _vm._v(" "), _c('span', {
      staticClass: "voice-arrow"
    }, [_vm._v("→")]), _vm._v(" "), _c('span', {
      staticClass: "voice-proposed"
    }, [_vm._v(_vm._s(_vm.formatValue(field, _vm.fields[field.key])))])])]), _vm._v(" "), _c('i', {
      staticClass: "icon-valid voice-chip-check"
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.bottleMatch) ? _c('div', {
    staticClass: "voice-bottle"
  }, [(_vm.bottleMatch.status === 'trouvee') ? _c('div', {
    staticClass: "voice-card"
  }, [_c('label', {
    staticClass: "voice-card-toggle",
    class: {
      checked: _vm.bottleChecked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bottleChecked),
      expression: "bottleChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.bottleChecked) ? _vm._i(_vm.bottleChecked, null) > -1 : (_vm.bottleChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.bottleChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.bottleChecked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.bottleChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.bottleChecked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })]), _vm._v(" "), _c('div', {
    staticClass: "voice-card-body"
  }, [_c('strong', [_vm._v("Manipulation bouteille")]), _vm._v(" "), _c('p', [_vm._v("\n                        " + _vm._s(_vm.bottleMatch.typeOp.realType) + " — bouteille "), _c('strong', [_vm._v(_vm._s(_vm.bottleMatch.bouteille.code))]), _vm._v(" "), (_vm.bottleMatch.bouteille.fluide) ? _c('span', [_vm._v(" (" + _vm._s(_vm.bottleMatch.bouteille.fluide.nom) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "voice-card-row"
  }, [_vm._v("\n                        Quantité\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.quantite),
      expression: "quantite",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "voice-quantite",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.001"
    },
    domProps: {
      "value": (_vm.quantite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantite = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n                        Kg\n                    ")])])]) : (_vm.bottleMatch.status === 'ineligible') ? _c('div', {
    staticClass: "voice-info"
  }, [_c('i', {
    staticClass: "icon-warning"
  }), _vm._v("\n                Bouteille " + _vm._s(_vm.bottleMatch.bouteille.code) + " détectée mais non éligible pour \"" + _vm._s(_vm.typeOperationLabel) + "\"\n                (fluide différent, pleine ou inactive). Vérifiez manuellement dans \"Manipulation de fluide\".\n            ")]) : (_vm.bottleMatch.status === 'fluide_manquant') ? _c('div', {
    staticClass: "voice-info"
  }, [_c('i', {
    staticClass: "icon-warning"
  }), _vm._v("\n                Aucun fluide n'est associé à cette installation, la manipulation de bouteille dictée ne peut pas être proposée.\n            ")]) : _vm._e(), _vm._v(" "), (['introuvable', 'ambigu'].includes(_vm.bottleMatch.status)) ? _c('div', [_c('div', {
    staticClass: "voice-info"
  }, [_c('i', {
    staticClass: "icon-warning"
  }), _vm._v(" "), (_vm.bottleMatch.status === 'introuvable') ? _c('span', [_vm._v("Aucune bouteille correspondant au code dicté n'a été trouvée.")]) : _c('span', [_vm._v("Plusieurs bouteilles correspondent au code dicté.")]), _vm._v(" "), (_vm.bottleMatch.eligibleBouteilles.length > 0) ? _c('span', [_vm._v(" Sélectionnez-la manuellement :")]) : _vm._e()]), _vm._v(" "), (_vm.bottleMatch.eligibleBouteilles.length > 0) ? _c('div', {
    staticClass: "voice-card"
  }, [_c('label', {
    staticClass: "voice-card-toggle",
    class: {
      checked: _vm.bottleChecked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bottleChecked),
      expression: "bottleChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.bottleChecked) ? _vm._i(_vm.bottleChecked, null) > -1 : (_vm.bottleChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.bottleChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.bottleChecked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.bottleChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.bottleChecked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })]), _vm._v(" "), _c('div', {
    staticClass: "voice-card-body"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manualBouteilleId),
      expression: "manualBouteilleId"
    }],
    staticClass: "voice-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.manualBouteilleId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Sélectionnez une bouteille")]), _vm._v(" "), _vm._l((_vm.bottleMatch.eligibleBouteilles), function(b) {
    return _c('option', {
      key: b.id,
      domProps: {
        "value": b.id
      }
    }, [_vm._v("\n                                " + _vm._s(b.code) + " — " + _vm._s(b.fluide ? b.fluide.nom : 'Indéfini') + " — " + _vm._s(b.poids_net) + "/" + _vm._s(b.poids_max) + " Kg\n                            ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "voice-card-row"
  }, [_vm._v("\n                            Quantité\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.quantite),
      expression: "quantite",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "voice-quantite",
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.001"
    },
    domProps: {
      "value": (_vm.quantite)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantite = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n                            Kg\n                        ")])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.fourniture) ? _c('div', {
    staticClass: "voice-card"
  }, [_c('label', {
    staticClass: "voice-card-toggle",
    class: {
      checked: _vm.fournitureChecked
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fournitureChecked),
      expression: "fournitureChecked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.fournitureChecked) ? _vm._i(_vm.fournitureChecked, null) > -1 : (_vm.fournitureChecked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.fournitureChecked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.fournitureChecked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.fournitureChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.fournitureChecked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-valid"
  })]), _vm._v(" "), _c('div', {
    staticClass: "voice-card-body"
  }, [_c('strong', [_vm._v("Ajout d'une fourniture")]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.fourniture.designation || '(désignation manquante)') + "\n                    "), (_vm.fourniture.etat) ? _c('span', [_vm._v(" — " + _vm._s(_vm.fourniture.etat))]) : _vm._e(), _vm._v(" "), (_vm.fourniture.quantite) ? _c('span', [_vm._v(" — Qté " + _vm._s(_vm.fourniture.quantite))]) : _vm._e(), _vm._v(" "), (_vm.fourniture.prix_unitaire) ? _c('span', [_vm._v(" — " + _vm._s(_vm.fourniture.prix_unitaire) + "€ HT")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "voice-actions"
  }, [_c('a', {
    staticClass: "btn close",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('a', {
    staticClass: "btn confirm",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("Valider la sélection")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b369a17e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/subcomponents/VoiceInterventionModal.vue
// module id = 784
// module chunks = 0